import { Img } from "@/components/blocks/MaterialImage";
import { FC } from "react";

export const CheckIcon: FC<{hostURL:string}> = ({hostURL}) => 
            <Img alt="" height={35} width={25} src={`${hostURL}/wcsstore/IntertoysSAS/images/colors/color1/checkMark_USPs.png`} />